// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewPlants_wrapper__ENG7X","container":"ViewPlants_container__b3b3S","footer":"ViewPlants_footer__JqKzr"};